import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attr-shape-02",
  "use": "icon-attr-shape-02-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-attr-shape-02\"><path d=\"m14.835 5.774-9.68 20.099C4.69 26.839 5.328 28 6.32 28h19.36c.994 0 1.63-1.161 1.165-2.127l-9.68-20.099c-.494-1.032-1.834-1.032-2.33 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol